import { Link } from 'react-router-dom';

const Services = () => {
  const services = [
    {
      icon: 'ri-paint-brush-line',
      title: 'Kitchen Remodeling',
      description: 'Transform your kitchen into a modern, functional space with custom cabinetry, countertops, and layouts designed for your lifestyle.',
      link: '/services/kitchen-remodeling',
    },
    {
      icon: 'ri-home-smile-line',
      title: 'Bathroom Renovation',
      description: 'Create your dream bathroom with luxurious fixtures, elegant tile work, and smart storage solutions that maximize space.',
      link: '/services/bathroom-renovation',
    },
    {
      icon: 'ri-building-line',
      title: 'Basement Finishing',
      description: 'Turn your unfinished basement into valuable living space - from entertainment rooms to home offices and guest suites.',
      link: '/services/basement-finishing',
    },
    {
      icon: 'ri-door-open-line',
      title: 'Room Additions',
      description: 'Expand your living space with seamlessly integrated room additions that match your home\'s existing architecture.',
      link: '/services/room-additions',
    },
    {
      icon: 'ri-hammer-line',
      title: 'Custom Carpentry',
      description: 'Expert craftsmanship for built-in shelving, crown molding, wainscoting, and custom woodwork that adds character to your home.',
      link: '/services/custom-carpentry',
    },
    {
      icon: 'ri-home-gear-line',
      title: 'Whole Home Remodeling',
      description: 'Complete home transformations that reimagine your entire living space with cohesive design and expert execution.',
      link: '/services/whole-home-remodeling',
    },
  ];

  return (
    <section id="services" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">Our Services</h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            From concept to completion, we deliver exceptional remodeling services tailored to your vision and budget.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div
              key={index}
              className="bg-gradient-to-br from-gray-50 to-white p-8 rounded-xl border border-gray-200 hover:border-teal-500 hover:shadow-xl transition-all duration-300 group"
            >
              <div className="w-16 h-16 flex items-center justify-center bg-teal-500 text-white rounded-lg mb-6 group-hover:scale-110 transition-transform duration-300">
                <i className={`${service.icon} text-3xl`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">{service.title}</h3>
              <p className="text-gray-600 mb-6 leading-relaxed">{service.description}</p>
              <Link
                to={service.link}
                className="text-teal-600 font-semibold hover:text-teal-700 transition-colors duration-200 flex items-center gap-2 cursor-pointer whitespace-nowrap"
              >
                Learn More
                <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;